import { ReactNode } from "react";
import styled from "@emotion/styled";
import { Button, Card, Space } from "antd";
import { useBookingWizard } from "../../contexts/BookingWizardContext";
import { useTranslation } from "react-i18next";

const StepContainer = styled(Card)`
  max-width: 800px;
  margin: 20px auto;
`;

const ButtonContainer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
`;

// Removing unused ButtonContainer component
export interface WizardStepProps {
  children: ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
  isLastStep?: boolean;
  nextButtonText?: string;
  nextDisabled?: boolean;
}

export const WizardStep = ({
  children,
  onNext,
  onPrevious,
  isLastStep,
  nextButtonText,
}: WizardStepProps) => {
  const { state } = useBookingWizard();
  const { t } = useTranslation();
  const isSubmitted = state.status === "submitted";

  return (
    <StepContainer>
      <div style={{ marginBottom: 24 }}>{children}</div>
      <ButtonContainer>
        <Space>
          {onPrevious && (
            <Button onClick={onPrevious} disabled={isSubmitted}>
              {t("common.previous")}
            </Button>
          )}
          {onNext && (
            <Button type="primary" onClick={onNext} disabled={isSubmitted}>
              {nextButtonText ||
                (isLastStep ? t("common.submit") : t("common.next"))}
            </Button>
          )}
        </Space>
      </ButtonContainer>
    </StepContainer>
  );
};
